import React from 'react'
import './InputSearch.css'
import {Input} from 'antd';

const InputSearch = ({
  clearInput,
  addonAfterElement,
  inputSearch,
  onChangeInputHandler,
  isDisabled,
  placeholderText,
  restrictSpace=true,
}) => {
  const onSearch = (value) => {
    const trimmedInputSearch = restrictSpace ?value?.trim():value;
    onChangeInputHandler(trimmedInputSearch);
  };

  return (
    <div className="inventory-input-search">
      <Input
        addonAfter={addonAfterElement || null}
        allowClear={clearInput || true}
        value={inputSearch || null}
        onChange={(e) => onSearch(e.target.value)}
        placeholder={placeholderText}
        disabled={isDisabled || false}
        // Prevent default behavior that might interfere with space input
        onKeyDown={(e) => {
          if (e.key === " ") {
            e.stopPropagation();
          }
        }}
      />
    </div>
  );
};

export default InputSearch